// Define the possible component actions for the reducer to call.
export const ACTIONS = {
  SET_CREW: "setCrew",
  SET_CONTRACTOR: "setContractor",
  SET_CREW_TYPE: "setCrewType",
  SET_SUPERVISOR: "setSupervisor",
  SET_FOREMAN: "setForeman",
  SET_DRILL_OPERATOR: "setDrillOperator",
  SET_LOCATOR: "setLocator",
  FOREMAN_PHONE: "setForemanPhone",
  FOREMAN_EMAIL: "setForemanEmail",
  SET_FORM_VALID: "setFormValid",
  SET_STATUS: "setStatus",
  TOGGLE_LOADING: "toggleLoading",
  RESET_FORM: "resetForm",
  INITIALIZE_FORM: "initializeForm",
  INITIALIZE_CONTRACTOR: "initialzieContractor",
  SET_CONTRACTOR_OPTIONS: "setContractorOptions",
  SET_MODE: "setMode",
  TOGGLE_ENABLED_STATUS: "toggleEnabledStatus",
};

// Define the state's initial values.
export const initialState = {
  selectedContractor: { value: "", label: "Search Contractors..." },
  selectedCrew: { value: "", label: "Search Crews..." },
  selectedCrewType: { value: "", label: "Select Crew Type" },
  supervisor: "",
  foreman: "",
  drillOperator: "",
  locator: "",
  foremanPhone: "",
  foremanEmail: "",
  foremanPhoneError: false,
  foremanEmailError: false,
  formValid: false,
  status: "",
  loading: false,
  crewGUID: "",
  contractorOptions: [],
  mode: "",
  enabledStatus: true,
  // The value of fetchCrews only serves to trigger the useEffect dependency
  // when it changes, so toggling it will trigger the refetch of crews.
  fetchCrews: true,
};

const setPhoneError = (state, value) => {
  state.foremanPhoneError =
    value.length === 0 ? false : !/^\d{3}-\d{3}-\d{4}$/.test(value);
};

const setEmailError = (state, value) => {
  state.foremanEmailError =
    value.length === 0 ? false : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

const resetForm = (state) => {
  state.selectedCrewType = initialState.selectedCrewType;
  state.supervisor = "";
  state.foreman = "";
  state.drillOperator = "";
  state.locator = "";
  state.foremanPhone = "";
  state.foremanEmail = "";
  state.foremanPhoneError = false;
  state.foremanEmailError = false;
  state.formValid = false;
  state.crewGUID = "";
  state.enabledStatus = true;
};

const initializeForm = (state) => {
  let selectedCrew = state?.selectedCrew?.value;
  state.crewGUID = selectedCrew?.CREW_GUID ? selectedCrew?.CREW_GUID : "";
  state.supervisor = selectedCrew?.SUPERVISOR ? selectedCrew.SUPERVISOR : "";
  state.foreman = selectedCrew?.FOREMAN ? selectedCrew.FOREMAN : "";
  state.drillOperator = selectedCrew?.DRILL_OPERATOR
    ? selectedCrew.DRILL_OPERATOR
    : "";
  state.locator = selectedCrew?.LOCATOR ? selectedCrew.LOCATOR : "";
  state.foremanPhone = selectedCrew?.FOREMAN_PHONE
    ? selectedCrew.FOREMAN_PHONE
    : "";
  state.foremanEmail = selectedCrew?.FOREMAN_EMAIL
    ? selectedCrew.FOREMAN_EMAIL
    : "";
  state.selectedCrewType = {
    label: selectedCrew.TYPE,
    value: selectedCrew.TYPE,
  };
  state.enabledStatus = selectedCrew?.ENABLED === 1;
  initializeSelectedContractor(state, state?.selectedCrew);
};

const formValid = (state) => {
  return (state.formValid =
    !state.foremanPhoneError &&
    !state.foremanEmailError &&
    state.selectedCrewType.value &&
    state.selectedContractor.value &&
    state.foreman.length > 0);
};

const initializeSelectedContractor = (state, selectedCrew) => {
  if (state.mode === "Edit") {
    let selectedContractor = state.contractorOptions.find(
      (obj) =>
        obj.value.MCA_NUMBER === selectedCrew?.value?.CONTRACTOR_MCA_NUMBER
    );
    state.selectedContractor = selectedContractor
      ? selectedContractor
      : initialState.selectedContractor;
    state.formValid = formValid(state);
  } else {
    state.selectedContractor = initialState.selectedContractor;
  }
};

// Define the component's reducer with an action switch and state handling.
export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_CREW:
      resetForm(state);
      return {
        ...state,
        selectedCrew: action.value,
      };
    case ACTIONS.SET_CONTRACTOR:
      return {
        ...state,
        selectedContractor: action.value,
      };
    case ACTIONS.SET_CREW_TYPE:
      return {
        ...state,
        selectedCrewType: action.value,
      };
    case ACTIONS.SET_SUPERVISOR:
      return {
        ...state,
        supervisor: action.value,
      };
    case ACTIONS.SET_FOREMAN:
      return {
        ...state,
        foreman: action.value,
      };
    case ACTIONS.SET_DRILL_OPERATOR:
      return {
        ...state,
        drillOperator: action.value,
      };
    case ACTIONS.SET_LOCATOR:
      return {
        ...state,
        locator: action.value,
      };
    case ACTIONS.FOREMAN_PHONE:
      setPhoneError(state, action.value);
      return {
        ...state,
        foremanPhone: action.value,
      };
    case ACTIONS.FOREMAN_EMAIL:
      setEmailError(state, action.value);
      return {
        ...state,
        foremanEmail: action.value,
      };
    case ACTIONS.SET_FORM_VALID:
      let valid = formValid(state);
      return {
        ...state,
        formValid: valid,
      };
    case ACTIONS.SET_STATUS:
      return {
        ...state,
        status: action.value,
        loading: false,
      };
    case ACTIONS.TOGGLE_LOADING:
      return {
        ...state,
        loading: state.loading ? false : true,
      };
    case ACTIONS.RESET_FORM:
      resetForm(state);
      return {
        ...state,
        selectedCrew: initialState.selectedCrew,
        loading: state.loading ? false : true,
        fetchCrews: state.fetchCrews ? false : true,
      };
    case ACTIONS.INITIALIZE_FORM:
      resetForm(state);
      initializeForm(state);
      return {
        ...state,
      };
    case ACTIONS.INITIALIZE_CONTRACTOR:
      initializeSelectedContractor(state, state.selectedCrew);
      return {
        ...state,
      };
    case ACTIONS.SET_CONTRACTOR_OPTIONS:
      return {
        ...state,
        contractorOptions: action.value,
      };
    case ACTIONS.SET_MODE:
      return {
        ...state,
        mode: action.value,
      };
    case ACTIONS.TOGGLE_ENABLED_STATUS:
      return {
        ...state,
        enabledStatus: state.enabledStatus ? false : true,
      };
    default:
      return state;
  }
};
